import {
  BridgeParentEventType,
  BridgeReadyStatus,
  PayloadError,
  PayloadParentToChild,
} from "iframe-bridge"
import { createContext } from "react"

import { IBridgeDiagnostics } from "./types"

export interface IBridgeContext {
  iframeRef: React.RefObject<HTMLIFrameElement>
  iframeUrl: string
  iframeOrigin: string
  // The `enabled` prop this provider was mounted with — lets a consumer
  // distinguish "bridge intentionally turned off" from any other state.
  enabled: boolean
  lastError: PayloadError | null
  ready: boolean
  // Connection lifecycle for the current iframe session. See beginConnection.
  status: BridgeReadyStatus
  // Why the current handshake hasn't reached "ready" yet, for a consumer's
  // own debug UI. Cleared on ready; re-armed on every beginConnection().
  diagnostics: IBridgeDiagnostics
  // Arms a fresh handshake-timeout window; call when the iframe (re)opens.
  beginConnection: () => void
  // Clears the handshake-timeout window; call when the iframe closes/unmounts.
  endConnection: () => void
  send: (type: BridgeParentEventType, payload: PayloadParentToChild) => void
  // Fire-and-forget; never throws, so it's always safe on a close path.
  sendCancelProcess: () => boolean
}

export const BridgeContext = createContext<IBridgeContext | null>(null)
